import React from 'react';
import './Merch.css';
import MerchBooth from './Booth/MerchBooth';

// The merch page is now the 3D booth (with a grid fallback + toggle inside).
export default function Merch() {
    return <MerchBooth />;
}
